// // ResponsiveNavbar.jsx
// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Logo from "../../assets/logo/logo07.png";
// import WidgetsIcon from '@mui/icons-material/Widgets';

// import "./navbar.css";

// const navLinks = [
//   { label: "Home", path: "/" },
//   { label: "Services", path: "/services" },
//   { label: "About Us", path: "/about" },
//   { label: "Contact", path: "/contact" },
//   { label: "Why Starlinklab", path: "/why-starlinklab" },
//   { label: "Portfolio", path: "/portfolio" },
// ];

// export default function ResponsiveNavbar({onClickModeOfCommunication}) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 840);

//   useEffect(() => {
//     function handleResize() {
//       setIsMobile(window.innerWidth <= 840);
//       if (window.innerWidth > 840) {
//         setMenuOpen(false);
//       }
//     }
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     document.body.style.overflow = menuOpen ? "hidden" : "";
//   }, [menuOpen]);

//   return (
//     <>
//       <nav className="navbar">
//         <div className="nav-container">
//           <div className="logo-slogan-wrapper">
//             <Link to="/" className="logo">
//               <img src={Logo} alt="logo" className="responsive-logo" />{" "}
//               {/* <p className="slogan-text">
//                 Starlinklab
//               </p> */}
//             </Link>
//           </div>

//           {!isMobile && (
//             <ul className="nav-links-desktop">
//               {navLinks.map(({ label, path }) => (
//                 <li key={label}>
//                   <Link to={path} className="nav-link">
//                     {label}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           )}

//           {isMobile && (
//             <button
//               className="hamburger-button"
//               onClick={() => setMenuOpen(!menuOpen)}
//             >
//               <span className="material-icons">
//                 {menuOpen ? "close" : <WidgetsIcon/>}
//               </span>
//             </button>
//           )}
//         </div>
//       </nav>

//       {isMobile && (
//         <>
//           <div
//             className={`mobile-menu-backdrop ${menuOpen ? "visible" : ""}`}
//             onClick={() => setMenuOpen(false)}
//           />
//           <aside className={`mobile-menu ${menuOpen ? "open" : ""}`}>
//             <ul className="mobile-menu-links">
//               {navLinks.map(({ label, path }) => (
//                 <li key={label}>
//                   <Link
//                     to={path}
//                     className="mobile-menu-link"
//                     onClick={() => setMenuOpen(false)}
//                   >
//                     {label}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </aside>
//         </>

//       )}
//     </>
//   );
// }

// rouetr

// components/Navbar/index.jsx

import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/logo/logo.png";
import WidgetsIcon from "@mui/icons-material/Widgets";
import "./navbar.css";

const navLinks = [
  { label: "Home", id:'/' },
  { label: "Services", id: "technologiesWeWorkOn" },
  // { label: "About Us", id:'about'},
  { label: "Why Starlinklab", id: "whyChooseUS" },
  { label: "Portfolio", id: "portfolio" },
  { label: "Contact", id: "contact" },
  { label: "Industries", id: "industriesWeServe" },
];

export default function ResponsiveNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 840);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 840);
      if (window.innerWidth > 840) {
        setMenuOpen(false);
      }
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
  }, [menuOpen]);

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    setMenuOpen(false);
  };

  return (
    <div className="navbarDivMain">
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="logo">
            <img src={Logo} alt="logo" className="responsive-logo" />
          </Link>

          {!isMobile && (
            <ul className="nav-links-desktop">
               
              {navLinks.map(({ label, id }) => (
                <li key={label}>
                  <button
                    className="nav-link"
                    onClick={() => scrollToSection(id)}
                  >
                    {label}
                  </button>
                </li>
              ))}
             <Link to="/aboutus">
                <button className="nav-link">AboutUs</button>
              </Link>
            </ul>
          )}

          {isMobile && (
            <button
              className="hamburger-button"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="material-icons">
                {menuOpen ? "close" : <WidgetsIcon />}
              </span>
            </button>
          )}
        </div>
      </nav>

      {isMobile && (
        <>
          <div
            className={`mobile-menu-backdrop ${menuOpen ? "visible" : ""}`}
            onClick={() => setMenuOpen(false)}
          />
          <aside className={`mobile-menu ${menuOpen ? "open" : ""}`}>
            <ul className="mobile-menu-links">
               <Link to="/aboutus">
                <button className="mobile-menu-link">AboutUs</button>
              </Link>
              {navLinks.map(({ label, id }) => (
                <li key={label}>
                  <button
                    className="mobile-menu-link"
                    onClick={() => scrollToSection(id)}
                  >
                    {label}
                  </button>
                </li>
              ))}
             
            </ul>
          </aside>
        </>
      )}
    </div>
  );
}
